module.exports = __webpack_public_path__ + "static/scale-model-of-redondo-boardwalk-llc-in-torrance-california-b144ac8dc0a04ff2e618b5ca843ebbb9.png";